import {
    SpiffDTO,
    SpiffClient_V1,
    VinDTO,
    SpiffSalesmanDTO,
    W9RequestSearchDTO,
    CreateSpiffRequestDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class SpiffService {
    private readonly _spiffClient: SpiffClient_V1;

    constructor() {
        this._spiffClient = new SpiffClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public GetSpiffs(dealerAccountUid: string, dto: SpiffDTO): Promise<Array<SpiffDTO>> {
        return this._spiffClient.getSpiffs(dto, dealerAccountUid);
    }

    public VinDetails(dealerAccountUid: string, vin: string): Promise<VinDTO>{
        return this._spiffClient.dynamicsVinInfo(dealerAccountUid, vin);
    }

    public RequestSpiff(dealerAccountUid: string, dto: CreateSpiffRequestDTO): Promise<CreateSpiffRequestDTO> {
       return ApiHelper.ParseDTO<CreateSpiffRequestDTO>(() =>this._spiffClient.requestSpiff(dto, dealerAccountUid));
    }

    public GetSpiffSalesmen(DealerAccountUid: string, dto: W9RequestSearchDTO): Promise<Array<SpiffSalesmanDTO>> {
        return this._spiffClient.getSpiffSalesmen(dto, DealerAccountUid);
    }
}